import { UserEntity } from "@/types/canonical";

export const USER_ROLES = {
  STUDENT: "student",
  PROCTOR: "proctor",
  TEACHER: "teacher",
  REVIEWER: "reviewer",
  MANAGER: "manager",
  ADMIN: "admin",
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const isStudent = (user: UserEntity | null | undefined): boolean => {
  return user?.group === USER_ROLES.STUDENT;
};

export const isProctor = (user: UserEntity | null | undefined): boolean => {
  return user?.group === USER_ROLES.PROCTOR;
};

export const isTeacher = (user: UserEntity | null | undefined): boolean => {
  return user?.group === USER_ROLES.TEACHER;
};

export const isReviewer = (user: UserEntity | null | undefined): boolean => {
  return user?.group === USER_ROLES.REVIEWER;
};

export const isManager = (user: UserEntity | null | undefined): boolean => {
  return user?.group === USER_ROLES.MANAGER;
};

export const isAdmin = (user: UserEntity | null | undefined): boolean => {
  return user?.group === USER_ROLES.ADMIN;
};

/**
 * Менеджерский доступ = может создавать/редактировать контент.
 * Студент, проктор и преподаватель сюда не входят: студент потребляет,
 * проктор наблюдает, преподаватель имеет доступ на уровне проктора
 * (только просмотр экзаменов).
 */
export const hasManagerAccess = (
  user: UserEntity | null | undefined
): boolean => {
  return !isStudent(user) && !isProctor(user) && !isTeacher(user);
};
